import { As, Text } from "@chakra-ui/react";

export interface IFeedCardText {
    value: string;
    as?: As;
}

export const FeedCardText = ({ value, as }: IFeedCardText) => <Text as={as}>{value}</Text>;
